<template>
  <div>
    <ministry-breadcrumbs :mainTitle="pageTitle" :breadcrumbs="breadcrumbs" />
    <b-card>
      <div class="ml-auto px-1" style="width: fit-content">
        <b-button @click="openFilterForm" type="submit" variant="success">
          <feather-icon class="mr-25" icon="FilterIcon" />
          فلترة</b-button
        >
        <b-button
          class="mx-50"
          @click="clearFilters"
          :disabled="!hasFilter"
          type="submit"
          variant="flat-danger"
        >
          <feather-icon class="mx-25" icon="XIcon" />
          الغاء الفلاتر</b-button
        >
        <b-button @click="exportTable" variant="outline-info">
          <feather-icon class="mr-25" icon="DownloadIcon" />
          تصدير الجدول</b-button
        >
      </div>

      <form-modal
        v-model="showFilterSidebar"
        :formSchema="{}"
        forceSide
        @confirm="onFilterConfirmed"
        ref="filterForm"
        title="فلترة التقرير"
        confirmLabel="فلترة"
        confirmIcon="FilterIcon"
      >
        <template #body>
          <advanced-reports-filters-renderer
            ref="filterFormRenderer"
            v-model="filtersForm"
            :formSchema="getFilterObject()"
          />
        </template>
      </form-modal>

      <graphql-data-table
        v-if="gqlQuery.length > 0"
        :key="gqlQuery"
        :query="gqlQuery"
        :fields="fields"
      />
    </b-card>
  </div>
</template>

<script>
import RouterDataTable from "@/components/router-data-table/index.vue";
import graphqlDataTable from "@/components/graphql-data-table";
import viewsMeta from "./views-meta";
import AdvancedReportsFiltersRenderer from "../../components/AdvancedReportsFiltersRenderer.vue";

import {
  BButton,
  BRow,
  BCol,
  BBreadcrumb,
  BBreadcrumbItem,
  BCard,
  BCardTitle,
  BFormRow,
  BForm,
  VBTooltip,
} from "bootstrap-vue";
import FormInput from "@/components/form-input/index.vue";
import FormSelect from "@/components/form-select/index.vue";
import FormModal from "@/components/FormModal.vue";
import { mapGetters, mapMutations, mapActions } from "vuex";
import LoadingOverlay from "@/components/LoadingOverlay.vue";
import MinistryBreadcrumbs from "../../components/MinistryBreadcrumbs.vue";
import axios from "axios";
import { graphQlQueryToJson } from "graphql-query-to-json";
import get from "lodash.get";
import set from "lodash.set";
import { jsonToGraphQLQuery } from "json-to-graphql-query";
import unset from "lodash.unset";
export default {
  components: {
    RouterDataTable,
    BButton,
    BRow,
    BCol,
    BBreadcrumb,
    BBreadcrumbItem,
    BCard,
    BCardTitle,
    BFormRow,
    BForm,
    FormInput,
    FormSelect,
    FormModal,
    LoadingOverlay,
    MinistryBreadcrumbs,
    graphqlDataTable,
    AdvancedReportsFiltersRenderer,
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  props: {
    view: String,
  },
  data() {
    return {
      showFilterSidebar: false,
      gqlQuery: "",
      filtersForm: {},
      hasFilter: false,
    };
  },
  computed: {
    ...mapGetters("AdvancedReports", ["queryFilters", "size", "page"]),
    pageTitle() {
      return viewsMeta[this.view].title;
    },
    fields() {
      return viewsMeta[this.view].fields;
    },

    breadcrumbs() {
      return viewsMeta[this.view].breadcrumbs || [];
    },
  },
  methods: {
    ...mapActions("Exporter", ["exportGqlToExcel"]),
    ...mapMutations("Exporter", ["setGqlQueryToExport"]),
    ...mapMutations("AdvancedReports", [
      "clearFilterSchema",
      "clearQuery",
      "setQuery",
      "setLoading",
    ]),
    clearFilters() {
      this.clearQuery();
      this.clearFilterSchema();
      this.filtersForm = {};
      var query = this.getQueryObj();
      query = this.setQueryArgs(query);
      this.gqlQuery = jsonToGraphQLQuery(query);
      this.$refs.filterFormRenderer.clearOperators();
      this.hasFilter = false;
    },
    openFilterForm() {
      this.showFilterSidebar = true;
    },

    exportTable() {
      var query = this.getQueryObj();
      var toExport = JSON.parse(JSON.stringify(query));
      toExport = toExport.query;
      unset(toExport[this.view], "pagintatorInfo");
      this.setGqlQueryToExport(toExport);
      this.exportGqlToExcel();
    },

    onFilterConfirmed() {
      var queryOptions = { first: this.size, page: this.page };
      if (Object.keys(this.queryFilters).length > 0)
        queryOptions.filter = this.queryFilters[this.view];
      var mainQuery = { ...this.getQueryObj() };
      mainQuery = this.setQueryArgs(mainQuery, queryOptions);
      this.gqlQuery = jsonToGraphQLQuery(mainQuery);
      this.hasFilter = true;
      var exportableQuery = JSON.parse(JSON.stringify(mainQuery));
      unset(exportableQuery, `query.${this.view}.paginatorInfo`);
      this.setGqlQueryToExport(exportableQuery.query);
      this.showFilterSidebar = false;
    },
    getQueryObj() {
      return get(viewsMeta, `${this.view}.queryObject`);
    },
    getFilterObject() {
      return get(viewsMeta, `${this.view}.filtersObject`);
    },
    setQueryArgs(query, args = { page: this.page, first: this.size }) {
      const res = { ...query };
      set(query, `query.${this.view}.__args`, args);
      return res;
    },
  },

  watch: {
    size() {
      this.onFilterConfirmed();
    },
    page() {
      this.onFilterConfirmed();
    },
  },

  mounted() {
    var query = this.getQueryObj();
    query = this.setQueryArgs(query);
    this.gqlQuery = jsonToGraphQLQuery(query);
  },
};
</script>
